module.exports = __webpack_public_path__ + "9a8106fa838d819252a875ee0cc162a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-768.jpg
// module id = 173
// module chunks = 0